exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2DjGpA6bpztzCIAHvLvgPU {\n  width: 62px; }\n", ""]);

// exports
exports.locals = {
	"container": "_2DjGpA6bpztzCIAHvLvgPU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/PlaylistButtons/styles.scss
// module id = 44
// module chunks = 0